import React from 'react'
import { Link } from "react-router-dom";


const OurTeam = () => {
  return (
    <>

      <section className="breadcrumb-wrapper fix bg-cover" style={{ backgroundImage: 'url(https://res.cloudinary.com/dnquglkeh/image/upload/v1771511829/SBS06987-Pano_2_xhjkdi.jpg)' }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2 className="wow fadeInUp" data-wow-delay=".3s">Administrative Officer</h2>
              <ul className="breadcrumb-list wow fadeInUp" data-wow-delay=".5s">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li><i className="fa-solid fa-chevron-right" /></li>
                <li>Administrative Officer</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section section-padding fix">
        <div className="container">
          <div className="row g-4">
            <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
              <div className="team-card-item mt-0">
                <div className="team-image">
                  <img src="assets/img/svp/Vivek Kumar Gautam.png" alt="img" />
                </div>
                <div className="team-content">
                  <h4 style={{textAlign:"center"}}>
                    <a to="team-details.html" style={{textAlign:"center"}}>Mr. Vivek Kumar Gautam</a>
                  </h4>
                  {/* <p style={{textAlign:"center"}}><b>( Administrator )</b></p> */}
                  <div className="social-profile">
                    <ul>
                      <li><a to="#"><i className="fa-brands fa-facebook" /></a></li>
                      <li><a to="#"><i className="fa-brands fa-twitter" /></a></li>
                      <li><a to="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                    </ul>
                    <span className="plus-btn"><i className="fa-solid fa-plus" /></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <div className="team-card-item mt-0">
                <div className="team-image">
                  <img src="assets/img/svp/Kalyan Parate.png" alt="img" />
                </div>
                <div className="team-content">
                  <h4 style={{textAlign:"center"}}>
                    <a to="team-details.html" style={{textAlign:"center"}}> Mr. Kalyan Parate</a>
                  </h4>
                  <p style={{textAlign:"center"}}><b>( Public Relations Officer )</b></p>
                  <div className="social-profile">
                    <ul>
                      <li><a to="#"><i className="fa-brands fa-facebook" /></a></li>
                      <li><a to="#"><i className="fa-brands fa-twitter" /></a></li>
                      <li><a to="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                    </ul>
                    <span className="plus-btn"><i className="fa-solid fa-plus" /></span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
              <div className="team-card-item mt-0">
                <div className="team-image">
                  <img src="assets/img/svp/Sanjay Kumar Tiwari.png" alt="img" />
                </div>
                <div className="team-content">
                  <h4 style={{textAlign:"center"}}>
                    <a to="team-details.html" style={{textAlign:"center"}}>Mr. Sanjay Kumar Tiwari</a>
                  </h4>
                  <p style={{textAlign:"center"}}><b>( Head of Office )</b></p>
                  <div className="social-profile">
                    <ul>
                      <li><a to="#"><i className="fa-brands fa-facebook" /></a></li>
                      <li><a to="#"><i className="fa-brands fa-twitter" /></a></li>
                      <li><a to="#"><i className="fa-brands fa-linkedin-in" /></a></li>
                    </ul>
                    <span className="plus-btn"><i className="fa-solid fa-plus" /></span>
                  </div>
                </div>
              </div>
            </div>
           
          </div>
        </div>
      </section>



    </>
  )
}

export default OurTeam